module.exports = __webpack_public_path__ + "img/114.2445ee22.jpg";